import React, { Component } from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'

import _ from 'lodash'
import moment from 'moment'
import history from '../../history'
import ReactTable from 'react-table'
import Loader from '../../util/Loader'
import { ModalRoute } from 'react-router-modal'
import { filterCaseInsensitive } from '../../util'
import { Tooltip, Button, Popconfirm } from 'antd'
import { actions as auditActions } from '../../redux/modules/auditActions'
import { actions as proposalActions } from '../../redux/modules/proposalActions'
import { actions as revisionActions } from '../../redux/modules/revisionActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import { actions as leadProposalActions } from '../../redux/modules/leadFunctions/leadProposalActions'
import { actions as leadEstimateActions } from '../../redux/modules/leadFunctions/leadEstimateActions'
import { actions as proposalTemplateActions } from '../../redux/modules/leadFunctions/proposalTemplateActions'

import AddEditFormModal from './components/proposals/AddEditFormModal.component'

import * as authSelectors from '../../selectors/auth'
import * as proposalSelectors from '../../selectors/lead/proposals'

const propTypes = {}
class LeadProposals extends Component {
  state = {
    modalIsShowing: false,
    currentId: -1,
    contentData: null,
    saveTemporarily: false,
    cloningMode: false
  }

  componentDidMount() {
    const { leadId } = this.props

    this.props.temporarilySavedLeadProposalsRefresh({
      leadId: leadId
    })
    this.props.getAllItems()
    this.props.leadEstimatesRefresh({
      leadId: leadId
    })
    this.props.getProposalTemplates()

    this.props.leadProposalsRefresh({
      leadId: leadId,
      next: (err, payload) => {
        const { proposalId } = this.props
        if (proposalId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(proposalId, 10) })
            this.setState({
              contentData: current
            })
            this.props.getRevisions({
              targetId: proposalId,
              table: 'proposal'
            })
            this.props.getLeadProposalSections(proposalId)
            this.props.getLeadProposalItems(proposalId)
            this.props.getProposalMilestone(proposalId)
          }
        }
      }
    })
  }

  handleProposalInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleRowClick = (row, clone = false) => {
    const { leadId } = this.props
    if (clone) {
      history.push(`/lead/${leadId}/proposals/clone/${row.id}`)
    } else {
      history.push(`/lead/${leadId}/proposals/edit/${row.id}`)
    }
    this.props.getRevisions({
      targetId: row.id,
      table: 'proposal'
    })
    this.setState({
      contentData: row
    })

    this.props.getLeadProposalSections(row.id)
    this.props.getLeadProposalItems(row.id)
    this.props.getProposalMilestone({ proposalId: row.id })
  }

  handleRowClickTemporarilySaved = row => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: row.content
    })

    this.props.setTemporaryProposalData(row)
    this.props.setTemporaryProposalMilestonesData(row)
  }

  handleAddButton = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/proposals/add`)
    this.setState({
      contentData: null
    })
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false,
      currentId: -1,
      contentData: null
    })
  }

  handleOverviewChange = value => {
    this.setState(() => ({ bodyText: value }))
  }

  clearProposalLocalStorage = () => {
    localStorage.removeItem('proposalsTemporarilySaved')
    this.setState({
      temporarilySavedProposals: []
    })
  }

  handleClone = row => {
    this.handleRowClick(row, true)

    this.setState({
      cloningMode: true,
      currentId: 0
    })
  }

  render() {
    if (!this.props.leadProposalActions.leadProposals) {
      return <Loader />
    }

    const { contentData } = this.state

    const { leadId, temporarilySavedProposals, leadProposals, proposalId } = this.props
    return (
      <div className="jobproposal">
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'add',
            leadId: leadId,
            contentData: contentData
          }}
          path={`/lead/:leadId/proposals/add`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'edit',
            leadId: leadId,
            contentData: contentData,
            proposalId: proposalId
          }}
          path={`/lead/:leadId/proposals/edit/:proposalId`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'clone',
            leadId: leadId,
            contentData: contentData,
            proposalId: proposalId
          }}
          path={`/lead/:leadId/proposals/clone/:proposalId`}
          exact
        />

        <div className="jobsBar">
          Proposals
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              CREATE Proposal
            </div>
          </div>
        </div>
        {leadProposals && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: () => {
                if (column.Header !== 'Clone') {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={leadProposals}
            columns={[
              {
                columns: [
                  {
                    Header: 'ID',
                    accessor: 'id',
                    maxWidth: 100
                  },
                  {
                    Header: 'Estimate ID',
                    id: 'estimate_id',
                    accessor: d => (
                      <Link
                        to={{ path: `#` }}
                        onClick={() => this.props.handleShortcut('Lead Estimates', d.estimate_id)}
                      >
                        {d.estimate_id}
                      </Link>
                    ),
                    maxWidth: 150
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 170
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name}  ${d.created_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.first_name}  ${d.original.last_name}`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name}  ${d.updated_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name}  ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Clone',
                    accessor: 'clone',
                    Cell: d => (
                      <div>
                        <Popconfirm
                          title="Are you sure you want to make a copy of this Proposal?"
                          onConfirm={() => this.handleClone(d.original)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            size="small"
                            icon="copy"
                            type="copy"
                            style={{ color: '#1F45B4' }}
                          />
                        </Popconfirm>
                      </div>
                    ),
                    width: 100
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}

        <div className="jobsBar">Temporarily Saved Proposals</div>
        {temporarilySavedProposals && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={temporarilySavedProposals}
            columns={[
              {
                columns: [
                  {
                    Header: 'Estimate ID',
                    id: 'estimate_id',
                    accessor: d => (
                      <Link
                        to={{ path: `#` }}
                        onClick={() => this.props.handleShortcut('Lead Estimates', d.estimate_id)}
                      >
                        {d.estimate_id}
                      </Link>
                    ),
                    maxWidth: 150
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadProposalActions: state.leadProposalActions,
  proposalTemplate: state.proposalTemplate,
  leadEstimateActions: state.leadEstimateActions,
  auditActions: state.auditActions,
  proposalActions: state.proposalActions,
  revisionActions: state.revisionActions,
  user: authSelectors.getUser(state, props),
  temporarilySavedProposals: proposalSelectors.getTemporarilySavedProposals(state, props),
  leadProposals: proposalSelectors.getProposals(state, props),
  proposalId: proposalSelectors.getProposalIdParam(state, props)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      itemActions,
      leadProposalActions,
      proposalTemplateActions,
      leadEstimateActions,
      auditActions,
      proposalActions,
      revisionActions
    ),
    dispatch
  )
})
LeadProposals.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadProposals))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadProposals.container.js